// src/features/assistant-connect/utils/guide.ts
//
// The shape of each assistant's tab: its sections, how many numbered steps each has, and which
// step is followed by a literal block (a command or a configuration file) to copy. The words are
// in i18n under `assistantConnect.assistants.<id>.sections.<section>`; this file only says how
// many there are and where the copyable blocks go, so the page renders them all the same way.

import { buildConnectCommand, cursorConfig, vscodeConfig, type AssistantId } from '../constants';

export interface GuideSection {
  key: string;
  steps: number;
  /** A literal block shown right after step `afterStep`. */
  block?: { afterStep: number; value: (serverUrl: string) => string };
  /** Whether the section has a closing note. */
  note?: boolean;
}

export const GUIDE: Record<AssistantId, GuideSection[]> = {
  claude: [
    { key: 'apps', steps: 4, note: true },
    { key: 'code', steps: 2, block: { afterStep: 1, value: buildConnectCommand } },
  ],
  chatgpt: [{ key: 'web', steps: 5 }],
  copilot: [{ key: 'vscode', steps: 4, block: { afterStep: 2, value: vscodeConfig } }],
  cursor: [{ key: 'ide', steps: 3, block: { afterStep: 2, value: cursorConfig } }],
};
